/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    GetAccountStatusResponse,
    GetStripeAccountResponse,
} from '../models';

export interface CommentSoldAggregateApiControllerGetAccountStatusRequest {
    userId: string;
}

export interface CommentSoldAggregateApiControllerGetStripeAccountRequest {
    userId: string;
}

/**
 * 
 */
export class CommentSoldAggregateApiApi extends runtime.BaseAPI {

    /**
     */
    async commentSoldAggregateApiControllerGetAccountStatusRaw(requestParameters: CommentSoldAggregateApiControllerGetAccountStatusRequest): Promise<runtime.ApiResponse<GetAccountStatusResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling commentSoldAggregateApiControllerGetAccountStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/users/{userId}/get-account-status`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async commentSoldAggregateApiControllerGetAccountStatus(requestParameters: CommentSoldAggregateApiControllerGetAccountStatusRequest): Promise<GetAccountStatusResponse> {
        const response = await this.commentSoldAggregateApiControllerGetAccountStatusRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async commentSoldAggregateApiControllerGetStripeAccountRaw(requestParameters: CommentSoldAggregateApiControllerGetStripeAccountRequest): Promise<runtime.ApiResponse<GetStripeAccountResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling commentSoldAggregateApiControllerGetStripeAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/users/{userId}/get-stripe-account`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async commentSoldAggregateApiControllerGetStripeAccount(requestParameters: CommentSoldAggregateApiControllerGetStripeAccountRequest): Promise<GetStripeAccountResponse> {
        const response = await this.commentSoldAggregateApiControllerGetStripeAccountRaw(requestParameters);
        return await response.value();
    }

}
